import React from 'react';
import './Home.css';
import Header from '../Header/Header.js';
import Solucao from '../Solucao/Solucao.js';
import Sobre from '../Sobre/Sobre.js';
import Diferencial from '../Diferencial/Diferencial.js';
import Depoimentos from '../Depoimentos/Depoimentos.js';
import Especialidades from '../Especialidades/Especialidades.js';
import Contato from '../Contato/Contato.js';
import Enderecos from '../Enderecos/Enderecos.js';
import Faq from '../Faq/Faq.js';
import CtaFinal from '../CtaFinal/CtaFinal.js';
import Footer from '../Footer/Footer.js';

export default function Home() {
  return (
    <div className="">
      <Header />
      <Solucao />
      <Sobre />
      <Diferencial />
      {/* <Depoimentos  /> */}
      <Especialidades />
      <Contato />
      <Enderecos />
      <Faq />
      <CtaFinal />
      <Footer />
    </div>
  );
}